import { RECAPTCHA_CLIENT_KEY } from 'config';

export function bootRecaptcha () {
  const scriptElem = document.createElement("script");
  scriptElem.setAttribute("src", `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_CLIENT_KEY}`);
  document.body.appendChild(scriptElem);
}

export function executeRecaptcha (actionName: string): Promise<string> {
  if (!('grecaptcha' in window)) throw new Error('Recaptcha not present');
  const grecaptcha: any = window.grecaptcha;
  return new Promise((resolve, reject) => {
    grecaptcha.ready(() => {
      grecaptcha.execute(
        RECAPTCHA_CLIENT_KEY,
        { action: actionName }
      ).then(resolve, reject)
    })
  })
}
